import { ProductVariantEndpoints } from '@/modules/inventory/product-variant/api/productVariantEndpoints'

export const productVariantEndpoints = new ProductVariantEndpoints()
